import { render, staticRenderFns } from "./StepProgramDocuments.vue?vue&type=template&id=ebe765f8"
import script from "./StepProgramDocuments.vue?vue&type=script&lang=js"
export * from "./StepProgramDocuments.vue?vue&type=script&lang=js"
import style0 from "./StepProgramDocuments.vue?vue&type=style&index=0&id=ebe765f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports